import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import api from '@/utils/api';
import { toast } from 'sonner';
import { FileDown, Loader2 } from 'lucide-react';

export const ModelLetterDownloadButton = ({ courseId }) => {
  const [available, setAvailable] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/courses/${courseId}/model-letter/active`)
      .then((res) => setAvailable(!!res.data.has_letter))
      .catch(() => setAvailable(false));
  }, [courseId]);

  if (!available) return null;

  const download = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const res = await api.get(`/courses/${courseId}/model-letter/download`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Letter_of_Model_Acquisition.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error('Failed to download letter');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button size="sm" variant="outline" className="w-full rounded-full" onClick={download} disabled={busy} data-testid={`download-model-letter-${courseId}`}>
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileDown className="h-4 w-4 mr-2" />}
      Download Letter
    </Button>
  );
};
